<template>
  <el-row>
    <el-col :xs="24" :sm="6" :md="5" :lg="12" :xl="10">
      <el-card>
        <div slot="header" class="clearfix">
          <span class="cadastro-title">Novo Usuário</span>
        </div>
        <el-form label-position="left" label-width="100px" :model="user" ref="user" v-loading="isSaving">
          <el-form-item label="Nome" prop="name" :error="errors.name">
            <el-input v-model="user.name"></el-input>
          </el-form-item>
          <el-form-item label="Email" prop="email" :error="errors.email">
            <el-input v-model="user.email"></el-input>
          </el-form-item>
          <el-form-item label="Grupos" prop="roles" error="errors.roles">
            <el-checkbox-group size="mini" v-model="user.roles" :min="1">
              <el-checkbox-button label="Administrator" name="roles" value="1">Administrador</el-checkbox-button>
              <el-checkbox-button label="Seeder" name="roles">Seeder</el-checkbox-button>
              <el-checkbox-button label="Normal" name="roles">Normal</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="warning" @click="toList()">Lista</el-button>
            <el-button type="danger">Cancelar</el-button>
            <el-button type="primary" @click="onSubmit">Criar</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>

  import {error_form_transform} from "../../domain/utils";
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "user-create",
    data() {
      return {
        isSaving: false,
        errors: {
          name: null,
          email: null,
          roles: null
        },
        user: {
          name: '',
          email: '',
          roles: []
        }
      }
    },
    methods: {
      ...mapActions('User', ['createNew']),
      async onSubmit() {
        try {

          this.isSaving = true
          await this.createNew(this.user)
          this.$refs.user.resetFields();
          this.$notify.success("Registro Salvo com sucesso!")
        }
        catch (error) {
          this.errors = error_form_transform(error)
        }
        finally {
          this.isSaving = false
        }
      },
      toList() {
        this.$router.push({name: 'user.index'})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/User/Create.vue